import { Routes } from '@angular/router';
import { ROUTES } from './shared/constants/routes';
import { authGuard } from './shared/guards/auth.guard';
import { commonAccessGuard } from './shared/guards/common-access.guard';
import { ROUTE_ACCESS } from './shared/constants/route-access';

export const routes: Routes = [
  {
    path: ROUTES.LOGIN.path,
    loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage),
  },
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: ROUTES.DASHBOARD.path, pathMatch: 'full' },
      {
        path: ROUTES.DASHBOARD.path,
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.DashboardPage),
      },
      {
        path: ROUTES.EMPLOYEE_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/employee-management/employee-management').then(
            (m) => m.EmployeeManagementPage,
          ),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.EMPLOYEE_MANAGEMENT.path],
      },
      {
        path: ROUTES.EMPLOYEE_BULK_UPLOAD.path,
        loadComponent: () =>
          import('./pages/employee-bulk-upload/employee-bulk-upload').then(
            (m) => m.EmployeeBulkUploadPage,
          ),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.EMPLOYEE_BULK_UPLOAD.path],
      },
      {
        path: ROUTES.ADDITIONAL_EMAILS.path,
        loadComponent: () =>
          import('./pages/additional-emails/additional-emails').then((m) => m.AdditionalEmailsPage),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.ADDITIONAL_EMAILS.path],
      },
      {
        path: ROUTES.ROLE_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/roles-management/roles-management').then((m) => m.RolesManagementPage),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.ROLE_MANAGEMENT.path],
      },
      {
        path: ROUTES.TASK_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/tasks-management/tasks-management').then((m) => m.TasksManagementPage),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.TASK_MANAGEMENT.path],
      },
      {
        path: ROUTES.DEPARTMENT_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/department-management/department-management').then(
            (m) => m.DepartmentManagementPage,
          ),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.DEPARTMENT_MANAGEMENT.path],
      },
      {
        path: ROUTES.DESIGNATION_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/designation-management/designation-management').then(
            (m) => m.DesignationManagementPage,
          ),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.DESIGNATION_MANAGEMENT.path],
      },
      {
        path: ROUTES.BRAND_MANAGEMENT.path,
        loadComponent: () =>
          import('./pages/brand-management/brand-management').then((m) => m.BrandManagementPage),
        canActivate: [commonAccessGuard],
        data: ROUTE_ACCESS[ROUTES.BRAND_MANAGEMENT.path],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
